import React, { useEffect, useState } from 'react';
import { Button, Card, Form, Image, Message } from 'semantic-ui-react';
import './LoginPage.scss';
import * as yup from 'yup';
import { Formik } from 'formik';
import { TextField } from './../common/FormFields';
import * as userActions from './../../redux/actions/userActions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

const validationSchema = yup.object({
  username: yup.string().required('A username is required'),
  password: yup.string().required('A password is required'),
});

const initialValues = {
  username: '',
  password: '',
};

const LoginPage = ({
  errorMessage,
  successMessage,
  match,
  history,
  loggedIn,
  login,
  loading,
  loginOauth,
  resetPassword,
}) => {
  const [message, setMessage] = useState(null);
  const [reset, setReset] = useState(false);
  const handleSubmit = credentials => {
    login(credentials);
  };

  useEffect(() => {
    if (loggedIn && history && (history.location.pathname === '/login' || history.location.pathname === '/')) {
      history.push('/home');
    }
  }, [loggedIn]);

  useEffect(() => {
    if (successMessage) {
      setReset(false);
    }
  }, [errorMessage, successMessage]);

  return (
    <div className="gm-page login-page-body">
      <Formik validationSchema={validationSchema} onSubmit={handleSubmit} initialValues={initialValues}>
        {formik => (
          <Form id="login-form" onSubmit={formik.handleSubmit} error={Boolean(formik.touched && formik.errors)}>
            <Card className="login-card">
              <Card.Content textAlign="center">
                <Image src="/static/logo.svg" />
              </Card.Content>
              <Card.Content textAlign="center">
                <Card.Header style={{ fontWeight: 200 }}>
                  {reset ? 'Reset Password' : 'Login to your account'}
                </Card.Header>
              </Card.Content>
              <Card.Content>
                {(errorMessage || message) && <Message error content={errorMessage || message} />}
                {successMessage && <Message success content={successMessage} />}

                <TextField
                  data-cy="username"
                  name="username"
                  label="Email address"
                  type="text"
                  value={formik.values.username}
                  onChange={formik.handleChange}
                  error={formik.touched.username && Boolean(formik.errors.username)}
                  errorMessage={formik.errors.username}
                />

                {!reset && (
                  <TextField
                    data-cy="password"
                    name="password"
                    label="Password"
                    type="password"
                    value={formik.values.password}
                    onChange={formik.handleChange}
                    error={formik.touched.password && Boolean(formik.errors.password)}
                    errorMessage={formik.errors.password}
                  />
                )}
              </Card.Content>
              <Card.Content extra>
                {!reset && (
                  <Button type="submit" data-cy="submit" fluid positive>
                    Login
                  </Button>
                )}
                <br />
                <Button
                  as="a"
                  loading={loading}
                  onClick={() => {
                    if (!formik.values.username && reset) {
                      return setMessage('Please enter a valid username');
                    }

                    if (reset) {
                      resetPassword(formik.values.username);
                      setReset(false);
                      setMessage('');
                    }

                    setReset(true);
                  }}
                  fluid
                >
                  {reset ? 'Reset Password' : 'Forgot Password?'}
                </Button>
              </Card.Content>
            </Card>
          </Form>
        )}
      </Formik>
    </div>
  );
};

const mapStateToProps = state => ({
  errorMessage: state.user.errorMessage,
  successMessage: state.user.successMessage,
  loggedIn: state.user.loggedIn,
  loading: state.user.loading,
});

const mapDispatchToProps = dispatch => ({
  login: bindActionCreators(userActions.login, dispatch),
  loginOauth: bindActionCreators(userActions.loginOauth, dispatch),
  resetPassword: bindActionCreators(userActions.resetPassword, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage);
